var map = {
	"./basketchat.jpg": 8800,
	"./biryani.jpg": 6733,
	"./bisibelebath.jpg": 861,
	"./butterchicken.jpg": 4002,
	"./chholebhature.jpg": 3959,
	"./coffee.jpg": 2607,
	"./dalbatichurma.jpg": 6525,
	"./dhokla.webp": 6387,
	"./fafda.jpg": 2182,
	"./ghevar.jpg": 7198,
	"./gulautikebab.jpg": 6315,
	"./haleem.webp": 8339,
	"./handvo.jpg": 7173,
	"./icecream.jpg": 5957,
	"./idli.jpg": 7935,
	"./iranichai.webp": 6550,
	"./kachori.jpg": 155,
	"./kathiroll.jpg": 8893,
	"./kebabs.jpg": 2354,
	"./khaman.jpg": 3805,
	"./lalmass.jpg": 7975,
	"./masaladosa.webp": 8638,
	"./misalpav.jpg": 2223,
	"./mistidoi.jpg": 5147,
	"./momos.jpg": 6822,
	"./mysorepak.jpg": 1149,
	"./osmaniabiscuit.jpg": 5428,
	"./panipuri.jpg": 4947,
	"./paranthe.jpg": 7956,
	"./pavbhaji.jpg": 4943,
	"./pizza.jpg": 6309,
	"./pyazkachori.jpg": 958,
	"./rosogolla.jpg": 1764,
	"./sheermal.webp": 6180,
	"./tundeykebab.jpg": 8524,
	"./vadapav.jpg": 3468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4651;